import { QueryClient } from '@tanstack/react-query'

/**
 * Refetches everything the access layer reads: the company list plus the
 * account / roles / effective-permissions projection behind `useUser()`.
 *
 * Creating a company (wizard or .bak restore) grants the creator a role on it,
 * but those three queries hold a 5-minute-stale snapshot taken before it
 * existed — so redirecting into the new company renders the no-permission
 * screen until the snapshot happens to refetch. Await this before navigating.
 *
 * Never rejects: callers await it on the happy path of a flow that has already
 * succeeded (the restore is done, the company exists), so a failed refetch must
 * not abort the redirect that follows.
 */
export function invalidateAccessQueries(queryClient: QueryClient) {
  return Promise.allSettled([
    queryClient.invalidateQueries({ queryKey: ['config.companies'] }),
    queryClient.invalidateQueries({ queryKey: ['config.user'] }),
    queryClient.invalidateQueries({ queryKey: ['config.roles'] }),
    queryClient.invalidateQueries({ queryKey: ['config.effectivePermissions'] }),
  ])
}
